// extracted by mini-css-extract-plugin
export default {"wrapper":"searchInput_wrapper__NrmRV","input":"searchInput_input__LUOmZ","iconBtn":"searchInput_iconBtn__vR69v","icon":"searchInput_icon__KaEmw"};